import { Link } from 'react-router-dom';

const heroThumbs = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20dramatic%20male%20warrior%20character%20portrait%20with%20sword%2C%20dark%20atmospheric%20background%2C%20modern%20digital%20illustration%2C%20korean%20comic%20aesthetic%2C%20cinematic%20mood%2C%20rich%20contrast%2C%20professional%20webtoon%20artwork&width=400&height=533&seq=hero-thumb-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20romance%20cover%20art%2C%20beautiful%20female%20character%20portrait%2C%20soft%20warm%20lighting%2C%20dark%20atmospheric%20background%2C%20modern%20korean%20comic%20illustration%2C%20emotional%20aesthetic%2C%20professional%20webtoon%20artwork&width=400&height=533&seq=hero-thumb-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20mystery%20thriller%20cover%20art%2C%20intense%20detective%20character%20portrait%2C%20dark%20shadowy%20background%2C%20suspenseful%20mood%2C%20korean%20comic%20illustration%2C%20cinematic%20lighting%2C%20professional%20webtoon%20artwork&width=400&height=533&seq=hero-thumb-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20fantasy%20cover%20art%2C%20magical%20hero%20character%20portrait%2C%20dark%20mystical%20background%20with%20glowing%20elements%2C%20korean%20comic%20illustration%2C%20epic%20aesthetic%2C%20professional%20webtoon%20artwork&width=400&height=533&seq=hero-thumb-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20action%20cover%20art%2C%20dynamic%20fighter%20character%20portrait%2C%20dark%20dramatic%20background%2C%20intense%20energy%2C%20korean%20comic%20illustration%2C%20professional%20webtoon%20artwork&width=400&height=533&seq=hero-thumb-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20urban%20cover%20art%2C%20stylish%20character%20portrait%20in%20city%2C%20dark%20noir%20background%2C%20modern%20korean%20comic%20illustration%2C%20sophisticated%20aesthetic%2C%20professional%20webtoon%20artwork&width=400&height=533&seq=hero-thumb-06&orientation=portrait',
];

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20korean%20manhwa%20webtoon%20style%20collage%20of%20comic%20panels%20with%20dramatic%20lighting%2C%20action%20scenes%20and%20romance%20moments%2C%20deep%20black%20and%20charcoal%20background%20with%20subtle%20coral%20orange%20glow%20accents%2C%20artistic%20composition%2C%20atmospheric%20moody%20aesthetic%2C%20vertical%20scroll%20format%20hints%2C%20no%20text%2C%20abstract%20comic%20art%20blend&width=1600&height=900&seq=hero-bg-manhwa-01&orientation=landscape"
          alt="虚空韩漫网 - 正版韩漫大全"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/50 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/40 to-transparent"></div>
      </div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[45%] text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-300 bg-primary-500/10 rounded-full border border-primary-500/20 mb-6">
              正版授权 · 每日更新
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-foreground-50 leading-tight tracking-tight">
              正版韩漫
              <br />
              大全
            </h1>
            <p className="mt-6 text-base md:text-lg text-foreground-400 leading-relaxed max-w-md mx-auto lg:mx-0">
              虚空韩漫网提供<strong>正版韩漫大全</strong>和<strong>免费韩漫下拉式</strong>阅读体验。
              涵盖热血、恋爱、悬疑、奇幻等多种类型，在尊重版权的同时服务广大漫画爱好者。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/category/rexue"
                className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 border border-foreground-700/40 hover:border-foreground-500/60 text-foreground-400 hover:text-foreground-200 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>

            <div className="mt-10 flex items-center gap-8 justify-center lg:justify-start">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">300+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">正版资源</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">800万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃读者</div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[55%] hidden lg:block">
            <div className="relative">
              <div className="grid grid-cols-3 gap-4">
                <div className="flex flex-col gap-4">
                  <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] group">
                    <img src={heroThumbs[0]} alt="热门韩漫推荐" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                    <div className="absolute bottom-3 left-3 right-3">
                      <span className="text-xs text-foreground-300 bg-background-50/60 px-2 py-1 rounded-full">热门推荐</span>
                    </div>
                  </div>
                  <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] group">
                    <img src={heroThumbs[3]} alt="热门韩漫推荐" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                    <div className="absolute bottom-3 left-3 right-3">
                      <span className="text-xs text-foreground-300 bg-background-50/60 px-2 py-1 rounded-full">热门推荐</span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-4" style={{ marginTop: '40px' }}>
                  <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] group">
                    <img src={heroThumbs[1]} alt="热门韩漫推荐" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                    <div className="absolute bottom-3 left-3 right-3">
                      <span className="text-xs text-foreground-300 bg-background-50/60 px-2 py-1 rounded-full">热门推荐</span>
                    </div>
                  </div>
                  <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] group">
                    <img src={heroThumbs[4]} alt="热门韩漫推荐" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                    <div className="absolute bottom-3 left-3 right-3">
                      <span className="text-xs text-foreground-300 bg-background-50/60 px-2 py-1 rounded-full">热门推荐</span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-4">
                  <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] group">
                    <img src={heroThumbs[2]} alt="热门韩漫推荐" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                    <div className="absolute bottom-3 left-3 right-3">
                      <span className="text-xs text-foreground-300 bg-background-50/60 px-2 py-1 rounded-full">热门推荐</span>
                    </div>
                  </div>
                  <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] group">
                    <img src={heroThumbs[5]} alt="热门韩漫推荐" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                    <div className="absolute bottom-3 left-3 right-3">
                      <span className="text-xs text-foreground-300 bg-background-50/60 px-2 py-1 rounded-full">热门推荐</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -inset-8 bg-gradient-to-t from-background-50 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}